export default "__VITE_ASSET__117b8b66__"